const DeleteDomainColumn = [
  {
    title: 'Webpage Name',
    dataIndex: 'name',
    slot: 'webpageName',
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url',
    slot: 'webpageUrl',
  },
  {
    title: 'Health Status',
    dataIndex: 'healthStatus',
    slot: 'healthStatus',
  },
  {
    title: 'Monitoring Type',
    dataIndex: 'monitorType',
    slot: 'monitorType',
  }
];

export { DeleteDomainColumn };
